<template>
    <div>
        <div class="button-area">
            <Button @click="save()" :loading="saveLoading" type="primary" class="button-right-left">确认发布</Button>
            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form style="width: 1100px" ref="form" :model="model" :label-width="110" label-position="left" :rules="rules" inline>
                <FormItem :class="{'model-hidden': true}" label="文本框">
                    <Input v-model="model.id" type="text"></Input>
                </FormItem>

                <FormItem label="活动标题" prop="theme">
                    <Input v-model="model.theme" placeholder="活动标题" style="width:320px" clearable></Input>
                </FormItem>

                <FormItem label="活动类型" prop="serviceType">
                    <Select v-model="model.serviceType" placeholder="活动类型" style="width:320px" clearable>
                        <Option v-for="(item,index) in serviceType" :key='index' :value="item.serviceType">
                            {{item.serviceTypeName}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="活动时间" prop="activityTime">
                    <DatePicker @on-change="onChange" v-model="model.activityTime" type="datetimerange" placeholder="请选择" style="width: 320px"
                                 format="yyyy-MM-dd" clearable></DatePicker>
                </FormItem>

                <FormItem label="联系人" prop="concat">
                    <Input v-model="model.concat" placeholder="联系人" style="width:320px" clearable></Input>
                </FormItem>
                <FormItem label="联系电话" prop="phone">
                    <Input v-model="model.phone" placeholder="联系电话" style="width:320px" clearable></Input>
                </FormItem>
                <FormItem label="报名截止时间" prop="applyEndTime">
                    <DatePicker v-model="model.applyEndTime" placeholder="请选择" style="width: 320px" type="date"
                                format="yyyy-MM-dd"
                                clearable></DatePicker>
                </FormItem>
                <FormItem label="报名人数限制" prop="maxNum">
                    <Input :value="model.maxNum" @input="(e)=>model.maxNum = e===''?'':e - 0" placeholder="0代表人数不限制" style="width:320px" type="number">
                    </Input>
                </FormItem>
                <FormItem label="活动价格" prop="price">
                    <Input v-model="model.price" placeholder="0代表免费" style="width:320px" type="text" clearable>
                    </Input>
                </FormItem>
                <FormItem label="活动地址" prop="address">
                    <Input v-model="model.address" placeholder="请输入地址" style="width:320px" type="text" clearable>
                    </Input>
                </FormItem>
                <FormItem label="组织机构" prop="organization">
                    <Input v-model="model.organization" placeholder="" style="width:320px" clearable></Input>
                </FormItem>
                <FormItem  label="活动内容" prop="content">
                    <div id="content" style="width: 900px" v-model="model.content"></div>
                </FormItem>
                <br>
                
                <FormItem label="活动图片" prop="picPath">
                    <upload
                            v-model="model.picPath"
                            style="width:320px"
                            :action=uploadUrl
                            :headers="headers"
                            :limit="1"
                            list-type="picture-card"
                            :before-upload="beforeUpload"
                            :file-list="picList"
                            :on-exceed="onExceed"
                            :on-success="handlePicSuccess"
                            :on-remove="handlePicRemove">
                        <i class="el-icon-plus"></i>
                    </upload>
                    <span style="font-size:10px ; color: red">建议图片375*250</span>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </FormItem>
                
                <br>


            </Form>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js'
    import E from 'wangeditor'
    import upload from '@/components/upload'

    export default {
        components:{upload},
        name: 'tqtActivityForm',
        data () {
            return {
                //ID
                id: null,
                saveLoading: false,
                model: {},
                serviceType: [],
                uploadUrl: util.baseUrl + 'api/common/upload',
                headers: { 'Authorization': localStorage.token },
                dialogImageUrl: '',
                dialogVisible: false,
                picList: [],
                content:'',
                editor: null,
                editorData: '',
                rules: {
                    theme: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
                    serviceType: [{ required: true, message: '请选择活动类型', trigger: 'blur' }],
                    activityTime: [{
                            type: 'array',
                            required: true,
                            fields: {
                            0: {type: 'date', required: true, message: '请选择起止日期'},
                            1: {type: 'date', required: true, message: '请选择起止日期'}
                                    }
                            }],

                    concat: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
                    phone: [
                        { required: true, message: '请输入联系方式', trigger: 'blur' },
                        { pattern: /^[1][0-9]{10}$/, message: '请输入正确的手机号' },
                    ],
                    applyEndTime: [{required: true, message: '日期不能为空!', trigger: 'blur', pattern: /.+/}],
                    maxNum: [{ required: true,message: '请输入活动人数', trigger: 'input',type:'number' },{ type:"integer" ,message: '请输入整数', trigger: 'input' }],
                    organization: [{ required: true, message: '请输入组织机构', trigger: 'blur' }],
                    content: [{ required: true, message: '请活动内容', trigger: 'blur' }],
                    price: [{ required: true, message: '请活动报名价格', trigger: 'blur' }],
                    address: [{ required: true, message: '请输入活动地址', trigger: 'blur' }],
                    picPath: [{ required: true, message: '请上传照片', trigger: 'change' }],
                },
            }
            
        },
        watch:{
                content (val) {
                this.model.content = val
                this.editor.txt.html(this.model.content)
            }

                },
        mounted () {
            if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
                this.id = this.$route.query.id
                //ID存在渲染表单
                this.initForm()

            }
            this.tqtServiceTypeList()
            this.initEditor()
        },
        methods: {
             initEditor () {
                const editor = new E('#content')
                editor.customConfig.onchange = (newHtml) => {
                    this.content = newHtml
                }
                editor.customConfig.uploadImgServer = this.uploadUrl
                editor.customConfig.uploadFileName = 'file'
                editor.customConfig.menus = [
                    'head',  // 标题
                    'bold',  // 粗体
                    'fontSize',  // 字号
                    'fontName',  // 字体
                    'italic',  // 斜体
                    'underline',  // 下划线
                    'strikeThrough',  // 删除线
                    'foreColor',  // 文字颜色
                    'backColor',  // 背景颜色
                    'link',  // 插入链接
                    'list',  // 列表
                    'justify',  // 对齐方式
                    'quote',  // 引用
                    'emoticon',  // 表情
                    'image',  // 插入图片
                    'table',  // 表格
                ]
                editor.customConfig.zIndex = 3
                editor.customConfig.uploadImgHooks = {
                    before: function (xhr, editor, files) {
                        // 图片上传之前触发
                        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
                        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
                        // return {
                        //     prevent: true,
                        //     msg: '放弃上传'
                        // }
                    },
                    success: function (xhr, editor, result) {
                        // 图片上传并返回结果，图片插入成功之后触发
                        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                    },
                    fail: function (xhr, editor, result) {

                        // 图片上传并返回结果，但图片插入错误时触发
                        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                    },
                    error: function (xhr, editor) {

                        // 图片上传出错时触发
                        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                    },
                    timeout: function (xhr, editor) {
                        // 图片上传超时时触发
                        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                    },
                    // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
                    // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
                    customInsert: function (insertImg, result, editor) {
                        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
                        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                        let url = result.result.realPath
                        insertImg(url)
                        // result 必须是一个 JSON 格式字符串！！！否则报错
                    }
                }

                // 创建编辑器
                editor.create()
                // editor.txt.html(this.model.content)
                this.editor = editor
            },
            onCancel () {
                this.model = {}
                this.picList = []
            },
            tqtServiceTypeList () {
                this.$http.get('/api/common/tqtServiceTypeList', {
                    params: {}
                }).then(res => {
                    let list = res.data
                    this.serviceType = list.result
                })
            },
            onExceed () {
                this.$Notice.warning({
                    title: '只能上传一张图片!'
                })
            },
            handlePicSuccess (response, file, fileList) {
                if (response.success) {
                    this.model.picPath = response.result.path || ''
                    this.picList = fileList
                }
            },
            handlePicRemove (file, fileList) {
                this.model.picPath = ''
                console.log(file, fileList)
            },
            handlePictureCardPreview (file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            },
            beforeUpload (file) {
                const testImg = /^image\/(jpeg|png|jpg)$/.test(file.type)
                if (!testImg) {
                    this.$Notice.error({title: '上传图片只能是jpeg|png|jpg格式!'})
                    return false
                }
            },
            //保存
            save () {
                this.$refs['form'].validate((valid) => {
                    if (!valid) {
                        this.$Message.warning('请检查填写的信息');
                        return
                    }
                    if (this.id) {
                        this.update()
                    } else {
                        this.create()
                    }
                })

            },

            //渲染表单
            initForm () {
                let _this = this
                util.http.get('/api/tqtActivitys/' + this.id, {
                    params: {}
                }).then(function (response) {
                    let tem = response.data
                    _this.model = tem
                    _this.model.maxNum -= 0
                    _this.content = tem.content
                    _this.picList = _this.model.pic
                    _this.model.activityTime = [_this.model.startTime, _this.model.endTime]
                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '获取表单失败!'
                    })
                    console.log(error)
                })
            },

            // create(){
            //     let _this = this;
            //     _this.saveLoading=true;
            //     util.http
            //             .post("/api/tqtActivitys", this.model, {
            //                 headers: {
            //                     "Content-Type": "application/json"
            //                 }
            //             })
            //             .then(function (response) {
            //                 _this.$Notice.success({
            //                     title: '保存成功!'
            //                 });
            //                 _this.back()
            //             })
            //             .catch(function (error) {
            //                 _this.$Notice.error({
            //                     title: '保存失败!'
            //                 });
            //                 _this.saveLoading=false;
            //                 console.log(error);
            //             });
            // },

            update () {
                let _this = this
                _this.saveLoading = true
                util.http
                        .put('/api/tqtActivitys', this.model, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '更新成功!'
                            })
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '更新失败!'
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
            },

            //返回,需要自定义配置路由
            back () {
                let _this = this
                let tagName = _this.$route.name
                _this.$store.commit('removeTag', tagName)
                _this.$store.commit('closePage', tagName)
                _this.$router.push({
                    name: 'tqt_activity'
                })
            },
            onChange(val){
                if (val.length > 0) {
                    this.model.startTime = new Date(val[0])
                    this.model.endTime = new Date(val[1])
                }
            }
        }
    }
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        margin-top: 40px;
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden {
        display: none;
    }

</style>
